// src/components/BoardPackConfiguration/PagePreview.jsx

import { BoardPackLayout } from "./common/BoardPackLayout";
import GenericPagePreview from "./pages/GenericPagePreview";
import TitlePage from "./pages/title_page";
import LastTitle from "../BoardPack/pages/last_title";
import MainTable from "./pages/main_table";
import BarChart from "./pages/bar_chart";
import LargeTable from "./pages/large_table";
import ThirdTable from "./pages/third_table";
import KpiEnforcementTable from "./pages/kpi_enforcement_table";
import KpiChart12 from "./pages/kpi_chart_12";
import NewChartKPIPage from "./pages/new_chart_kpi";
import NewStackChartPage from "./pages/new_stack_chart";
import KpiChart12NEW from "./pages/kpi_chart_12_new";
import KpiChartNew from "./pages/kpi_chart_new";
import LineBars from "./pages/line_bars";
import Linebarstable from "./pages/line_bars_table";
import DonutChart18 from "./pages/donut_chart_18";
import AreaChartPage from "./pages/area_chart";
import Kpi_Chart_13 from "./pages/kpi_chart_13";
import KpiChart14 from "./pages/kpi_chart_14";
import NewChartComponentPage from "./pages/new_chart_component";
import PageOneChartContainer from "./pages/Dotted_line_chart";
import DonutChart from "./pages/donut_chart";

const PagePreview = ({ page }) => {
  const months = [
    "Jan",
    "Feb",
    "Mar",
    "Apr",
    "May",
    "Jun",
    "Jul",
    "Aug",
    "Sep",
    "Oct",
    "Nov",
    "Dec",
  ];

  const currentDate = new Date();
  const year = currentDate.getFullYear();
  const month = months[currentDate.getMonth()];

   const pageKey = JSON.stringify({
    title: page.title,
    subtitle: page.subtitle,
    datasets: page.datasets,
    barDatasets: page.barDatasets,
    yAxisLabel: page.yAxisLabel,
    in_chart_content_line_1: page.in_chart_content_line_1,
    showRamadanRow: page.showRamadanRow,
    ramadanBorderColor: page.ramadanBorderColor,
  });
  
  if (!page) return null;
  switch (page.type) {
    case "title_page":
      return (
        <BoardPackLayout>
          <TitlePage page={page} />
        </BoardPackLayout>
      );
    case "last_title":
      return (
        <BoardPackLayout>
          <LastTitle page={page} />
        </BoardPackLayout>
      );
    case "main_table":
      return (
        <BoardPackLayout isSidebar={false}>
          <MainTable page={page} />
        </BoardPackLayout>
      );
    case "large_table":
      return (
        <BoardPackLayout isSidebar={false}>
          <LargeTable page={page} />
        </BoardPackLayout>
      );
    case "third_table":
      return (
        <BoardPackLayout>
          <ThirdTable page={page} />
        </BoardPackLayout>
      );
    case "kpi_enforcement_table":
      return (
        <BoardPackLayout isSidebar={false}>
          <KpiEnforcementTable page={page} />
        </BoardPackLayout>
      );
    case "bar_chart":
      return (
        <BoardPackLayout isSidebar={false}>
          <BarChart page={page} />
        </BoardPackLayout>
      );
    case "kpi_chart_12":
      return (
        <BoardPackLayout isSidebar={false}>
          <KpiChart12 page={page} />
        </BoardPackLayout>
      );
    case "kpi_chart_12_new":
      return (
        <BoardPackLayout isSidebar={false}>
          <KpiChart12NEW page={page} />
        </BoardPackLayout>
      );
    case "new_chart_kpi":
      return (
        <BoardPackLayout isSidebar={false}>
          <NewChartKPIPage page={page} />
        </BoardPackLayout>
      );
    case "kpi_chart_new":
      return (
        <BoardPackLayout isSidebar={false}>
          <KpiChartNew page={page} />
        </BoardPackLayout>
      );
    case "new_stack_chart":
      return (
        <BoardPackLayout isSidebar={false}>
          <NewStackChartPage page={page} />
        </BoardPackLayout>
      );
     case "line_bars":
      return (
        <BoardPackLayout isSidebar={false}>
          <LineBars key={pageKey} page={page} />  {/* ✅ key add kiya */}
        </BoardPackLayout>
      );
    case "line_bars_table":
      return (
        <BoardPackLayout isSidebar={false}>
          <Linebarstable key={pageKey} page={page} /> 
        </BoardPackLayout>
      );
    case "donut_chart_18": return <BoardPackLayout isSidebar={false}><DonutChart18 page={page} /></BoardPackLayout>;
    case "donut_chart": return <BoardPackLayout isSidebar={false}><DonutChart page={page} /></BoardPackLayout>;
    case "area_chart":
      return (
        <BoardPackLayout isSidebar={false}>
          <AreaChartPage page={page} />
        </BoardPackLayout>
      );
    case "kpi_chart_13":
      return (
        <BoardPackLayout isSidebar={false}>
          <Kpi_Chart_13 page={page} />
        </BoardPackLayout>
      );
    case "kpi_chart_14":
      return (
        <BoardPackLayout isSidebar={false}>
          <KpiChart14 page={page} />
        </BoardPackLayout>
      );
    case "new_chart_component":
      return (
        <BoardPackLayout isSidebar={false}>
          <NewChartComponentPage page={page} />
        </BoardPackLayout>
      );
    case "Dotted_Line_Chart":
      return (
        <BoardPackLayout isSidebar={false}>
          <PageOneChartContainer page={page} />
        </BoardPackLayout>
      );

    default:
      return <GenericPagePreview page={page} />;
  }
};
export default PagePreview;
